// ---------------------------------------------------------------------------
// Build-time feature switches.
//
// CommonJS for the same reason as site.js: scripts/prerender.mjs reads these in
// plain Node, so the static HTML a crawler gets and the app a visitor gets are
// switched by the same line.
//
// DISCOUNTS_ENABLED — the membership-discount product (Volcyy/Volcyy Black,
// QR redemption, Stripe checkout). Volcyy pivoted to reviews and videos in
// September 2026 and the client asked to keep the discount system intact for a
// possible return, so nothing was deleted: flipping this to true brings back
// every route, badge, form field and page that was hidden. The matching server
// switch is DISCOUNTS_ENABLED at the top of functions/index.js — flip both.
// A build-time constant rather than a Firestore flag so hidden pages never
// flash on screen before a config read lands, and so the prerender can see it.
// ---------------------------------------------------------------------------

// META_VIDEOS_ENABLED — Instagram and Facebook videos. Turned off in
// October 2026: Meta's oEmbed gives no cover image and, since the
// November 2025 deprecation, no title or creator either, so those cards
// could only ever be a placeholder with no credit beside it, next to
// TikTok and YouTube cards showing a real frame. Nothing is deleted —
// the parsing, the embeds and the Meta oEmbed call all still work, so if
// Meta ever hands that data back this comes on with one line. The
// matching server switch is META_VIDEOS_ENABLED in functions/videos.js —
// flip both.
const META_VIDEOS_ENABLED = false;

// VIDEOS_ENABLED — the whole Videos section (the venue page shelf, the
// admin Videos tab and the policy wording about embeds). Turned off in
// October 2026 at the client's request: TikTok stopped returning cover
// images, and the section was cut rather than patched. Existing video
// records and the server functions are kept, so this is one line to undo.
const VIDEOS_ENABLED = false;

const DISCOUNTS_ENABLED = false;

module.exports = { DISCOUNTS_ENABLED, META_VIDEOS_ENABLED, VIDEOS_ENABLED };
